const getQueryErrorDescription = (statusCode: number | string, statusText: string): string => {
  statusText = statusText ? statusText : "неизвестен";
  statusCode = statusCode ? statusCode : "неизвестен";

  return `Ошибка при отправке запроса. Код ошибки: ${statusCode}, текст ошибки: ${statusText}`;
};

export default getQueryErrorDescription;
